import React, { useEffect, useState } from "react";
import "./BlockDeals.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";

export default function BlockDeals() {
    // WebSocket connection
    const { blockDealsData } = useStockApiWebsocket(
        environment.stockApiDayRangeDataWSUrl
    );
    const [blockDealsDataList, setBlockDealsDataList] = useState([]);
    /* ============================================== */

    useEffect(() => {
        if (Array.isArray(blockDealsData) && blockDealsData.length > 0) {
            setBlockDealsDataList(blockDealsData);
            console.log(blockDealsData);
        }
    }, [blockDealsData]);


    // Header Data
    const headerSource = blockDealsDataList?.[0] ?? {};
    const headerData = [
        {
            label1: "Date",
            value1: headerSource?.localDate ?? "--",
            label2: "Time",
            value2: headerSource?.localTime ?? "--",
        },
    ];

    return (
        <div className="block-deals-page">
            {/* ================= HEADER ================= */}
            <header className="header">
                <nav className="nav-container">
                    <div className="left-nav header-flex">
                        <div className="logo-container">
                            <img
                                src="/assets/images/noptionwave-logo-1.png"
                                className="header-logo"
                                alt="noptionwave logo"
                            />
                        </div>

                        {headerData.map((item, idx) => (
                            <div className="header-item" key={idx}>
                                <span className="header-line">
                                    {item.label1} : {item.value1}
                                </span>
                                <span className="header-line">
                                    {item.label2} : {item.value2}
                                </span>
                            </div>
                        ))}
                    </div>
                </nav>
            </header>

            <div className="table-container">
                <div className="block-deals-header">
                    <h2 className="block-deals-heading">
                        <span className="sectorial-indices-span">BLOCK DEALS</span>
                    </h2>
                </div>

                <table className="responsive-table text-center sticky-header">
                    <tbody>
                        {blockDealsDataList?.length > 0 ? (
                            blockDealsDataList.map((row, idx) => (
                                <tr key={idx}>
                                    <td className="deal-cell">

                                        <div className="deal-row">
                                            <span>{row.deal_date ?? "--"}</span>
                                            <span className="span-color-price">
                                                {row.deal_time
                                                    ? `${row.deal_time.slice(0, 2)}:${row.deal_time.slice(2)}`
                                                    : "--"}
                                            </span>
                                        </div>
                                    </td>
                                    <td> <span className="span-color-price">{row.sc_nseid ?? "--"}</span></td>
                                    <td><span className="span-color-price">Price: {row.tradedPrice ?? "--"}</span></td>
                                    <td className="deal-cell">
                                        <div className="deal-row">
                                           
                                            <span>Rs.</span>
                                            <span className="span-color">{row.dealValue ?? "--"} </span>

                                            <span>Crores</span>
                                            <span>NSE Block Trade For</span>
                                            <span className="span-color">{row.quantity ?? "--"}</span>
                                            <span>Shares</span>
                                            
                                            
                                        </div>
                                    </td>
                                    
                                    <td><span>Volume: {row.volume ?? "--"}</span></td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="15">Waiting for live data...</td>
                            </tr>
                        )}
                    </tbody>

                    <tfoot className="fixed-footer">
                        <tr className="footer-left">
                            <td colSpan="15">noptionwave © 2026</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
}
